import { Link, Stack } from "@mui/material";
import { useOktaAuth } from "@okta/okta-react";
import { useEffect } from "react";

import { useUserStore } from "../../stores/userStore";
import Text from "../atoms/Text";
import OmneByFwdIcon from "../icons/branding/OmneByFwdIcon";

const UnAuthorisedToUseApplication = () => {
  const { oktaAuth } = useOktaAuth();
  const [user, clearUser] = useUserStore(store => [
    store.user,
    store.clearUser,
  ]);

  useEffect(() => {
    window.addEventListener("beforeunload", clearUserWhenLeavingThePage);
    return () => {
      window.removeEventListener("beforeunload", clearUserWhenLeavingThePage);
    };
  }, []);

  const clearUserWhenLeavingThePage = (event: {
    preventDefault: () => void;
  }) => {
    event.preventDefault();
    if (user) {
      clearUser();
      oktaAuth.clearStorage();
    }
  };

  const logout = async () => {
    await oktaAuth.signOut();
    clearUser();
  };

  return (
    <Stack display={"flex"} alignItems={"center"} mt={20}>
      <OmneByFwdIcon />
      <Stack mt={5} alignItems={"center"}>
        <Text variant="title_large">
          You do not have permissions to access the platform
        </Text>
        <Text variant="title_large">
          Please contact your system administrator
        </Text>
        <Text variant="title_large">
          Click{" "}
          <Link component="button" onClick={logout}>
            <Text variant="title_large">
              <u>here</u>
            </Text>
          </Link>{" "}
          to go back home
        </Text>
      </Stack>
    </Stack>
  );
};

export default UnAuthorisedToUseApplication;
